const colorMap = {
  white: 'var(--sc-color-white)',
  normal: 'var(--sc-text-color)',
  desc: 'var(--sc-explanation-text-color)',
  main: 'var(--main-color)',
  primary: 'var(--sc-color-primary)',
  primaryHover: 'var(--sc-color-primary-hover)',
  warning: 'var(--sc-text-color-warning)',
  error: 'var(--sc-text-color-error)',
  outline: 'var(--sc-color-outline)',
  link: 'var(--sc-text-color-link)',
  gray100: 'rgb(243 244 246)',
  gray300: 'rgb(209 213 219 )',
};
const colorKey = Object.keys(colorMap).map((k) => k[0].toUpperCase() + k.slice(1));
const colorAlias = {
  text: 'color',
  bg: 'backgroundColor',
};

function getColors({ colors }: { colors: string[] }) {
  const colorStyle = {};
  colors.forEach((key) => {
    const ks = key.replace(/([A-Z0-9])/g, '-$1').split('-');

    const alias = ks[0];
    let color = ks.slice(1).join('');
    color = color[0].toLowerCase() + color.slice(1);

    colorStyle[colorAlias[alias]] = colorMap[color];
  });
  return { colorStyle };
}

function isColor(key: string) {
  return colorKey.find((k) => key.endsWith(k));
}

export { getColors, isColor };
